// extracted by mini-css-extract-plugin
module.exports = {"tabs":"PartnerTabs_tabs__9HpIi","tab":"PartnerTabs_tab__j55s8","tab__active":"PartnerTabs_tab__active__mHGME","tabIcon":"PartnerTabs_tabIcon__ElVXN"};